<template>
  <div id="lyvideowrap">
    <iframe
      name="videoFrame"
      src="static/videoApi/live.html"
      id="lyvideoFram"
      frameborder="0"
    ></iframe>
    <Button type="primary" long @click="Close">关闭所有视频</Button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      videoHight: 300,
    };
  },
  methods: {
    beforCcreatePlayer(v) {
      setTimeout(() => {
        window["videoFrame"].window.Close(-1);
        window["videoFrame"].window.Screens(4);
      }, 200);

      setTimeout(() => {
        for (let i = 1; i <= 4; i++) {
          window["videoFrame"].window.play(v, i);
        }
        var ddd = document.getElementById("lyvideo");

        //this.videoHight = ddd.clientHeight;
        console.log(this.videoHight);
      }, 400);
    },
    Close(t) {
      window["videoFrame"].window.Close(-1);
      this.$emit("closeVideo");
    },
  },
};
</script>
<style>
#lyvideowrap {
  width: 400px;
  height: 260px;
  border: none;
}
#lyvideoFram {
  width: 100%;
  height: 100%;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/com/locateVideo.vue